// React
import React from 'react';

// Packages

// Utilities
import { useActivityTagging } from 'utilities/hooks';
import { CONSTANTS } from 'utilities/configuration';

// Components
import {
    ActivityMetrics,
    ActivityReflections,
    ActivityDetails,
    ActivityChoice,
    ActivityDataCard,
    ActivitySetFieldValues,
} from '../_common';

const Name = CONSTANTS.ACTIVITIES.DEVELOPMENT;

const Choice = props => {
    return ActivityChoice({
        Name,
        methods: 'Initiative_Activity__c.Material_Type__c',
        fieldName: 'Material_Type__c',
        ...props,
    });
};

const DataCard = ({ item, theme = 'teal', mode = [] }) => {
    return (
        <ActivityDataCard
            {...{
                item,
                theme,
                methodsFieldName: 'Material_Type__c',
                tagTypes: [CONSTANTS.TAGS.DEVELOPMENT_ACTIVITY],
                showTags: mode.includes('tags'),
                showDetails: mode.includes('details'),
            }}
        />
    );
};

const Details = props => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const tagging = useActivityTagging({
        types: [CONSTANTS.TAGS.DEVELOPMENT_ACTIVITY],
    });

    // ///////////////////
    // METHODS
    // ///////////////////

    function getItemData(formData) {
        const { Material_Type__c } = formData;
        // Data for sf
        return {
            Material_Type__c,
        };
    }

    // ///////////////////
    // RETURN
    // ///////////////////

    return ActivityDetails({
        tagging: tagging.activity,
        getItemData,
        ...props,
    });
};

const Metrics = props => {
    return ActivityMetrics({
        Name,
        primary: true,
        secondary: true,
        allowSkipMetrics: true,
        ...props,
    });
};

const Reflections = props => {
    return ActivityReflections({
        primary: true,
        secondary: true,
        ...props,
    });
};

const setFieldValues = ({
    tagging,
    choice,
    form,
    id,
    utilities,
    REPORT_ID,
}) => {
    // ///////////////////
    // DETAILS
    // ///////////////////

    const { Material_Type__c } = utilities.activities.get(id);

    // Choice
    form.setValue('Material_Type__c', Material_Type__c);

    // ///////////////////
    // ALL THE OTHER STUFF
    // ///////////////////

    ActivitySetFieldValues({
        REPORT_ID,
        tagging,
        choice,
        form,
        id,
        utilities,
    });
};

export {
    Name,
    DataCard,
    Choice,
    Details,
    Metrics,
    Reflections,
    setFieldValues,
};
